import {getEnv} from '../../../../utils/getEnv'
import Cookies from 'js-cookie';

export function AdobeTag() {

  const env = getEnv();


  const loadScript = () => {

    const allVisibleCookies = Cookies.get();

    if (allVisibleCookies.hasOwnProperty('OptanonConsent')) {
      const cookieValues = allVisibleCookies.OptanonConsent.split('&');
      if (cookieValues.includes('groups=C0001:1,C0004:1')) return true
    }

    return false
  }



  if (env === 'staging' && loadScript()) {
    return "https://assets.adobedtm.com/a2ef59fba8e9/7f6d378ecd1a/launch-bbc1affd862a-staging.min.js"
  } else if (env === 'live' && loadScript()) {
    return "https://assets.adobedtm.com/a2ef59fba8e9/7f6d378ecd1a/launch-2ef5cb9792e7.min.js"
  }

  return null
}
